<template>
  <div class="dropdown-item dropdown-action dropdown-item--search">
    <slot :emitEvent="emitEvent">
      <div class="input-with-icon-container">
        <m-input-group class="my-0">
          <m-form-input
            :value="inputValue"
            :placeholder="placeholder"
            has-prefix-icon
            @input="emitEvent($event, 'input')"
            @change="emitEvent($event, 'change')"
            @update="emitEvent($event, 'update')"
            :debounce="debounce"
          />
          <m-icon
            variant="search"
            size="small"
            is-prefix-icon
          />
        </m-input-group>
      </div>
    </slot>
  </div>
</template>

<script>
import MFormInput from '../../FormInput';
import MIcon from '../../Icon';
import MInputGroup from '../../InputGroup';

export default {
  name: 'MDropdownSearch',
  components: {
    MFormInput,
    MIcon,
    MInputGroup,
  },
  props: {
    placeholder: {
      type: String,
      default: 'Enter input',
    },
    inputValue: {
      type: String,
      default: '',
    },
    inputId: {
      type: Number,
      default: 0,
    },
    debounce: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    emitEvent($event, eventName) {
      this.$emit(eventName, { value: $event, inputId: this.inputId });
    },
  },
};
</script>

<style scoped>
.dropdown-item--search {
  position: sticky;
  background: #fff;
  top: 0;
  z-index: 10;
}
</style>
